export default __webpack_public_path__ + "static/media/a037-student-t3-9.e78fb030.svg";